<template>
  <div>
    <div class="jumbotron">
      <div class="container marketing">
        <div class="row ">
          <div class="col-lg-8 col-xs-10"
               style="width:90%;background: #FFFFFF;padding:5%;border-radius: 5px;margin: 5%">
            <el-row>
              <span><b>产品：</b></span>
              <el-autocomplete
                  v-model="ratailOutRepositoryData.productNumber"
                  :clearable="true"
                  :fetch-suggestions="querySearchAsync"
                  placeholder="请输入产品编号"
                  @select="handleSelect"
              ></el-autocomplete>
            </el-row>
            <div>
              <a-tabs v-model:activeKey="ratailOutRepositoryData.codeType" size="default">
                <a-tab-pane key="1" tab="直接出库"></a-tab-pane>
                <a-tab-pane key="2" tab="区间出库"></a-tab-pane>
              </a-tabs>

              <!--              码显示区-->
              <div style="min-height: 50px">
                <div style="margin: 15px" v-show="ratailOutRepositoryData.bigCodes.size>0">
                  <h5>大标</h5>
                  <ul>
                    <li v-for="item in ratailOutRepositoryData.bigCodes" :key="item">{{ item }}
                      <span style="margin-left: 25px;color: red" @click="delCode(item,'big')">删除</span>
                    </li>
                  </ul>
                </div>
                <div style="margin: 15px" v-show="ratailOutRepositoryData.midCodes.size>0">
                  <h5>中标</h5>
                  <ul>
                    <li v-for="item in ratailOutRepositoryData.midCodes" :key="item">{{ item }}
                      <span style="margin-left: 25px;color: red" @click="delCode(item,'mid')">删除</span>
                    </li>
                  </ul>
                </div>
                <div style="margin: 15px" v-show="ratailOutRepositoryData.smallCodes.size>0">
                  <h5>小标</h5>
                  <ul>
                    <li v-for="item in ratailOutRepositoryData.smallCodes" :key="item">{{ item }}
                      <span style="margin-left: 25px;color: red" @click="delCode(item,'small')">删除</span>
                    </li>
                  </ul>
                </div>
              </div>

              <el-row style="margin-top: 10px">
                <el-col :span="18">
                  <a-button type="primary" size="small" @click.native="scanCode">扫码</a-button>
                </el-col>
                <el-col :span="6">
                  <a-button size="small" type="primary" @click.native="outRepository">零售出库</a-button>
                </el-col>
              </el-row>
              <div style="margin-top: 20px;border-top: solid 1px #8b8b8b;padding-top: 10px">
              </div>
              <el-row>
                <el-col :span="12">
                  <span style="color: rgb(29, 142, 242)"><b>即将出库：</b>{{ willOut }}</span>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {
  countRatailByCodes,
  getProductList,
  ratailOutRepository
} from "../api/data_bind";
import {matchCode} from "../utils/matchCode";

export default {
  data() {
    return {
      bigLen: [],
      midLen: [],
      smallLen: [],
      willOut: 0,
      ratailOutRepositoryData: {
        bigCodes: new Set(),
        midCodes: new Set(),
        smallCodes: new Set(),
        productId: 0,
        productNumber: '',
        codeType: '1',
      },
    };
  },
  created() {
    // 获取扫码数据
    this.bigLen = this.$store.state.codeLen.big
    this.midLen = this.$store.state.codeLen.mid
    this.smallLen = this.$store.state.codeLen.small
    if (this.$store.state.RatailOutRepository !== null) {
      this.ratailOutRepositoryData = this.$store.state.RatailOutRepository
    }
    if (this.$store.state.pre !== 'fromScan') {
      return
    }
    if (this.$store.state.code !== '') {
      this.freshCode()
    }
    this.$store.commit("setPre", '')
  },
  mounted() {
  },
  computed: {
    formItemLayout() {
      const {layout} = this.form;
      return layout === "horizontal"
          ? {
            labelCol: {span: 4},
            wrapperCol: {span: 14},
          }
          : {};
    },
    buttonItemLayout() {
      const {layout} = this.form;
      return layout === "horizontal"
          ? {
            wrapperCol: {span: 14, offset: 4},
          }
          : {};
    },
  },
  methods: {
    querySearchAsync(queryString, cb) {
      var params = {}
      if (queryString !== '') {
        params = {productNumber: queryString}
      }
      getProductList(params).then((res) => {
        if (res.code == 200) {
          this.restaurants = []
          for (const i in res.data.list) {
            let d = res.data.list[i]
            d['value'] = d.productName + '(' + d.productNumber + ')'
            this.restaurants.push(d)
          }
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            cb(this.restaurants);
          }, 300);
        }
      });
    },
    handleSelect(item) {
      this.ratailOutRepositoryData.productNumber = item.productNumber
      this.ratailOutRepositoryData.productId = item.productId
      this.$store.commit("setRatailOutRepositoryProduct", this.ratailOutRepositoryData)
    },
    delCode(code, type) {
      let delOk = false
      switch (type) {
        case 'big':
        case '大':
          delOk = this.ratailOutRepositoryData.bigCodes.delete(code)
          break
        case 'mid':
        case '中':
          delOk = this.ratailOutRepositoryData.midCodes.delete(code)
          break
        case 'small':
        case '小':
          delOk = this.ratailOutRepositoryData.smallCodes.delete(code)
          break
        default:
          return
      }
      if (delOk) {
        this.countOutByCodesApi()
      }
      this.$forceUpdate()
    },
    scanCode() {
      if (this.$store.state.isDev) {
        this.$store.commit("setScanCode", "89898990")
        this.freshCode()
        return;
      } else {
        this.$router.push({
          path: '/scanCodePage'
        });
      }

    },
    freshCode() {
      const c = this.$store.state.code;
      this.recordCode(c)
      this.$forceUpdate()
    },
    recordCode(code) {
      const codeName = matchCode(code, this.bigLen, this.midLen, this.smallLen)
      if (codeName === '无效') {
        this.$message.error("长度不符合要求，无效码" + code)
        return
      }
      if (codeName === '大') {
        const before = this.ratailOutRepositoryData.bigCodes.size
        this.ratailOutRepositoryData.bigCodes.add(code)
        if (this.ratailOutRepositoryData.bigCodes.size === before) {
          this.$message.error("重复扫码" + code)
          return
        }

      }
      if (codeName === '中') {
        const before = this.ratailOutRepositoryData.midCodes.size
        this.ratailOutRepositoryData.midCodes.add(code)
        if (this.ratailOutRepositoryData.midCodes.size === before) {
          this.$message.error("重复扫码" + code)
          return
        }

      }
      if (codeName === '小') {
        const before = this.ratailOutRepositoryData.smallCodes.size
        this.ratailOutRepositoryData.smallCodes.add(code)
        if (this.ratailOutRepositoryData.smallCodes.size === before) {
          this.$message.error("重复扫码" + code)
          return
        }
      }
      this.countOutByCodesApi()
    },
    countOutByCodesApi() {
      if (this.ratailOutRepositoryData.smallCodes.size + this.ratailOutRepositoryData.midCodes.size + this.ratailOutRepositoryData.bigCodes.size === 0) {
        return;
      }
      if (this.ratailOutRepositoryData.codeType === '2' && this.ratailOutRepositoryData.smallCodes.size + this.ratailOutRepositoryData.midCodes.size + this.ratailOutRepositoryData.bigCodes.size !== 2) {
        return;
      }
      let mySet = new Set()
      if (this.ratailOutRepositoryData.codeType === '2') {
        if (this.ratailOutRepositoryData.bigCodes.size === 2) {
          mySet = this.ratailOutRepositoryData.bigCodes
        } else if (this.ratailOutRepositoryData.midCodes.size === 2) {
          mySet = this.ratailOutRepositoryData.midCodes
        } else if (this.ratailOutRepositoryData.smallCodes.size === 2) {
          mySet = this.ratailOutRepositoryData.smallCodes
        } else {
          return
        }
      }
      let myArray = Array.from(mySet);
      let from = ''
      let to = ''
      if (myArray.length === 2) {
        from = myArray.reduce((min, current) => min < current ? min : current)
        to = myArray.reduce((max, current) => max > current ? max : current)
      }
      const params = {
        "from_number": from,
        "to_number": to,
        "big_number": Array.from(this.ratailOutRepositoryData.bigCodes),
        "mid_number": Array.from(this.ratailOutRepositoryData.midCodes),
        "small_number": Array.from(this.ratailOutRepositoryData.smallCodes),
        "product_id": this.ratailOutRepositoryData.productId,
        "product_number": this.ratailOutRepositoryData.productNumber
      }
      countRatailByCodes(params).then((res) => {
        if (res.code == 200) {
          if (this.willOut === res.data) {
            this.$message.error(this.$store.state.code + " 无效")
            this.delCode(this.$store.state.code, matchCode(this.$store.state.code, this.bigLen, this.midLen, this.smallLen))
            return
          }
          this.willOut = res.data
        }
      });
    },
    outRepository() {
      if (this.ratailOutRepositoryData.bigCodes.size === 2) {
        this.distanceOut()
      } else {
        this.allOut()
      }
    },
    distanceOut() {
      let mySet
      if (this.ratailOutRepositoryData.bigCodes.size === 2) {
        mySet = this.ratailOutRepositoryData.bigCodes
      } else if (this.ratailOutRepositoryData.midCodes.size === 2) {
        mySet = this.ratailOutRepositoryData.midCodes
      } else if (this.ratailOutRepositoryData.smallCodes.size === 2) {
        mySet = this.ratailOutRepositoryData.smallCodes
      } else {
        this.$message.error("请先扫出两个区间码")
        return
      }
      let myArray = Array.from(mySet);
      // 比较两个元素的大小，将小的值赋值给 from，大的值赋值给 to
      const params = {
        "from_number": myArray.reduce((min, current) => min < current ? min : current),
        "to_number": myArray.reduce((max, current) => max > current ? max : current),
        "product_id": this.ratailOutRepositoryData.productId,
        "product_number": this.ratailOutRepositoryData.productNumber
      }
      this.outRepositoryApi(params);
    },
    allOut() {
      if (this.ratailOutRepositoryData.bigCodes.size === 0 && this.ratailOutRepositoryData.midCodes.size === 0 && this.ratailOutRepositoryData.smallCodes.size === 0) {
        this.$message.error("请先扫码")
        return
      }
      const params = {
        "from_number": "",
        "to_number": "",
        "big_number": Array.from(this.ratailOutRepositoryData.bigCodes),
        "mid_number": Array.from(this.ratailOutRepositoryData.midCodes),
        "small_number": Array.from(this.ratailOutRepositoryData.smallCodes),
        "product_id": this.ratailOutRepositoryData.productId,
        "product_number": this.ratailOutRepositoryData.productNumber
      }
      this.outRepositoryApi(params);
    },
    outRepositoryApi(params) {
      ratailOutRepository(params).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg)
          this.ratailOutRepositoryData.midCodes.clear()
          this.ratailOutRepositoryData.smallCodes.clear()
          this.ratailOutRepositoryData.bigCodes.clear()
          if (this.willNeed === 0) {
            this.ratailOutRepositoryData = {
              selectChuKu: null,
              bigCodes: new Set(),
              midCodes: new Set(),
              smallCodes: new Set(),
              codeType: '1',
            }
          }
          location.reload()
        }
      });
    }
  },
}
;
</script>
<style scoped>
.marketing {
  margin-top: 50px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}

/deep/ .el-input {
  width: 220px;
  font-size: 11px;
}

::v-deep .el-autocomplete-suggestion {
  min-width: 200px;
  width: auto !important;
}

/deep/ .el-table .el-table__cell {
  padding: 1px;
  min-width: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
  text-align: left;
}

</style>